var _defs, _rect, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapBackgroundS1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 2097,
    viewBox: "0 0 1920 2097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-rs1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1596",
    "data-name": "Rectangle 1596",
    width: 1920,
    height: 2097,
    transform: "translate(0 102)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1.147,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c590c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#0c266c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7398fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.182,
    y1: 0.835,
    x2: 0.225,
    y2: 0.038,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c390c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_81",
    "data-name": "Mask Group 81",
    transform: "translate(0 -102)",
    clipPath: "url(#clip-path-rs1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7009",
    "data-name": "Group 7009"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 1920.5,
    height: 2760.57,
    transform: "translate(0 -16.57)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "digital_vector",
    "data-name": "digital vector",
    transform: "translate(-56.313 134.064)",
    opacity: 0.123
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6892",
    "data-name": "Group 6892",
    transform: "translate(6.7 448.167)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6835",
    "data-name": "Group 6835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15301",
    "data-name": "Path 15301",
    d: "M24.116-11.833V116.36L6.7,126.416V127.7l18.25-10.537L25.23,117V-11.833Z",
    transform: "translate(-6.701 11.833)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6836",
    "data-name": "Group 6836",
    transform: "translate(1041.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15302",
    "data-name": "Path 15302",
    d: "M483.606-11.833V116.36L356.092,189.98,228.577,116.36V-11.833h-1.112V117l128.348,74.1.278.16,128.349-74.1.279-.161V-11.833Z",
    transform: "translate(-227.465 11.833)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6837",
    "data-name": "Group 6837",
    transform: "translate(1298.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15303",
    "data-name": "Path 15303",
    d: "M537.876-11.833V116.36L410.361,189.98,282.847,116.36V-11.833h-1.113V117l128.349,74.1.279.16,128.349-74.1.278-.161V-11.833Z",
    transform: "translate(-281.734 11.833)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838",
    transform: "translate(1554.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15304",
    "data-name": "Path 15304",
    d: "M592.144-11.833V116.36L464.629,189.98,337.115,116.36V-11.833H336V117l128.349,74.1.278.16,128.349-74.1.278-.161V-11.833Z",
    transform: "translate(-336.003 11.833)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839",
    transform: "translate(1810.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15305",
    "data-name": "Path 15305",
    d: "M391.384,116.36V-11.833h-1.112V117l128.344,74.1.277.16,81.077-46.809v-1.286L518.893,189.98Z",
    transform: "translate(-390.272 11.833)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6840",
    "data-name": "Group 6840",
    transform: "translate(1426.188 127.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15306",
    "data-name": "Path 15306",
    d: "M437.5,312.308l-.278-.16-128.352-74.1V89.521l.278-.16L437.5,15.259l.278.16,128.347,74.1V238.046l-.278.16ZM309.982,237.4,437.5,311.024,565.01,237.4V90.163L437.5,16.543,309.982,90.163Z",
    transform: "translate(-308.868 -15.259)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841",
    transform: "translate(1682.33 127.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15307",
    "data-name": "Path 15307",
    d: "M491.763,312.308l-.274-.16-128.352-74.1V89.521l.279-.16,128.347-74.1.278.16,128.347,74.1V238.046l-.279.16ZM364.251,237.4l127.512,73.62L619.274,237.4V90.163L491.763,16.543,364.251,90.163Z",
    transform: "translate(-363.137 -15.259)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842",
    transform: "translate(1938.469 155.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15308",
    "data-name": "Path 15308",
    d: "M499.037,262.508l-80.52-46.487V68.78l80.52-46.487V21.007L417.683,67.977l-.277.161V216.664l81.632,47.13Z",
    transform: "translate(-417.405 -21.007)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6843",
    "data-name": "Group 6843",
    transform: "translate(1554.261 349.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15309",
    "data-name": "Path 15309",
    d: "M464.629,359.306l-.278-.161L336,285.044V136.519l.279-.16,128.347-74.1.278.16,128.347,74.1V285.044l-.278.165ZM337.112,284.4l127.516,73.62L592.145,284.4V137.161L464.629,63.541l-127.516,73.62Z",
    transform: "translate(-336.003 -62.257)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6844",
    "data-name": "Group 6844",
    transform: "translate(1810.402 349.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15310",
    "data-name": "Path 15310",
    d: "M599.97,311.214l-81.077,46.808L391.384,284.4V137.162l127.51-73.619,81.077,46.808v-1.285l-80.8-46.649-.279-.16-128.344,74.1-.278.161V285.046l128.344,74.1.277.161L599.97,312.5Z",
    transform: "translate(-390.272 -62.257)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6845",
    "data-name": "Group 6845",
    transform: "translate(0 571.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15311",
    "data-name": "Path 15311",
    d: "M24.951,109.416l-.278-.161L6.7,119.632v1.286l17.972-10.376,127.51,73.619V331.4L24.673,405.02,6.7,394.644v1.286L24.4,406.146l.278.16,128.344-74.1.278-.161V183.517Z",
    transform: "translate(-6.701 -109.255)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6846",
    "data-name": "Group 6846",
    transform: "translate(1682.33 571.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15312",
    "data-name": "Path 15312",
    d: "M491.763,406.309l-.274-.165-128.352-74.1V183.517l.279-.16,128.347-74.1.278.16,128.347,74.1V332.047l-.279.161ZM364.251,331.4l127.512,73.62L619.274,331.4V184.159L491.763,110.543,364.251,184.159Z",
    transform: "translate(-363.137 -109.255)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847",
    transform: "translate(1938.469 598.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15313",
    "data-name": "Path 15313",
    d: "M499.037,356.505l-80.52-46.487V162.777l80.52-46.488V115l-81.355,46.97-.277.161V310.661l81.632,47.13Z",
    transform: "translate(-417.405 -115.004)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6848",
    "data-name": "Group 6848",
    transform: "translate(0 856.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15314",
    "data-name": "Path 15314",
    d: "M6.7,169.721v1.286l17.416,10.055V328.3L6.7,338.357v1.286l18.25-10.537.279-.161V180.418Z",
    transform: "translate(-6.701 -169.721)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6849",
    "data-name": "Group 6849",
    transform: "translate(17.418 793.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15315",
    "data-name": "Path 15315",
    d: "M139.012,453.307l-.278-.16-128.342-74.1V230.515l.278-.16,128.342-74.1.278.16,128.347,74.1V379.045l-.278.161ZM11.5,378.4l127.512,73.62L266.528,378.4V231.157L139.012,157.542,11.5,231.157Z",
    transform: "translate(-10.391 -156.253)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6850",
    "data-name": "Group 6850",
    transform: "translate(273.555 793.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15316",
    "data-name": "Path 15316",
    d: "M193.285,453.307l-.278-.16-128.347-74.1V230.515l.274-.16,128.352-74.1.278.16,128.347,74.1V379.045l-.278.161ZM65.768,378.4l127.516,73.62L320.8,378.4V231.157L193.285,157.542,65.768,231.157Z",
    transform: "translate(-64.659 -156.253)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851",
    transform: "translate(529.693 793.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15317",
    "data-name": "Path 15317",
    d: "M247.557,453.307l-.278-.16-128.352-74.1V230.515l.278-.16,128.352-74.1.279.16,128.347,74.1V379.045l-.279.161ZM120.041,378.4l127.516,73.62L375.069,378.4V231.157L247.557,157.542,120.041,231.157Z",
    transform: "translate(-118.927 -156.253)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852",
    transform: "translate(0 1015.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15318",
    "data-name": "Path 15318",
    d: "M24.951,203.412l-.278-.16L6.7,213.627v1.286l17.972-10.376,127.51,73.619V425.4L24.673,499.016,6.7,488.64v1.286L24.4,500.142l.278.161,128.344-74.1.278-.161V277.513Z",
    transform: "translate(-6.701 -203.251)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6853",
    "data-name": "Group 6853",
    transform: "translate(145.482 1015.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15319",
    "data-name": "Path 15319",
    d: "M166.15,500.3l-.278-.161-128.347-74.1V277.513l.278-.16,128.347-74.1.278.16,128.352,74.1V426.042l-.279.161ZM38.638,425.4l127.512,73.62L293.666,425.4V278.155L166.15,204.54,38.638,278.155Z",
    transform: "translate(-37.524 -203.251)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6854",
    "data-name": "Group 6854",
    transform: "translate(401.624 1015.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15320",
    "data-name": "Path 15320",
    d: "M220.419,500.3l-.278-.161-128.347-74.1V277.513l.278-.16,128.347-74.1.279.16,128.347,74.1V426.042l-.274.161ZM92.907,425.4l127.512,73.62L347.935,425.4V278.155L220.419,204.54,92.907,278.155Z",
    transform: "translate(-91.793 -203.251)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6855",
    "data-name": "Group 6855",
    transform: "translate(0 1300.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15321",
    "data-name": "Path 15321",
    d: "M6.7,263.717V265l17.416,10.055V422.3L6.7,432.353v1.286L24.951,423.1l.279-.16V274.414Z",
    transform: "translate(-6.701 -263.717)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856",
    transform: "translate(17.418 1236.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15322",
    "data-name": "Path 15322",
    d: "M139.012,547.3l-.278-.161-128.342-74.1V324.511l.278-.16,128.342-74.1.278.161,128.347,74.1V473.041l-.278.16ZM11.5,472.4l127.512,73.616L266.528,472.4V325.158l-127.516-73.62L11.5,325.158Z",
    transform: "translate(-10.391 -250.249)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857",
    transform: "translate(273.555 1236.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15323",
    "data-name": "Path 15323",
    d: "M193.285,547.3l-.278-.161-128.347-74.1V324.511l.274-.16,128.352-74.1.278.161,128.347,74.1V473.041l-.278.16ZM65.768,472.4l127.516,73.616L320.8,472.4V325.158l-127.512-73.62L65.768,325.158Z",
    transform: "translate(-64.659 -250.249)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858",
    transform: "translate(529.693 1236.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15324",
    "data-name": "Path 15324",
    d: "M247.557,547.3l-.278-.161-128.352-74.1V324.511l.278-.16,128.352-74.1.279.161,128.347,74.1V473.041l-.279.16ZM120.041,472.4l127.516,73.616L375.069,472.4V325.158l-127.512-73.62-127.516,73.62Z",
    transform: "translate(-118.927 -250.249)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859",
    transform: "translate(1554.261 1236.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15325",
    "data-name": "Path 15325",
    d: "M464.629,547.3l-.278-.161L336,473.041V324.511l.279-.16,128.347-74.1.278.161,128.347,74.1V473.041l-.278.16ZM337.112,472.4l127.516,73.616L592.145,472.4V325.158l-127.516-73.62-127.516,73.62Z",
    transform: "translate(-336.003 -250.249)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860",
    transform: "translate(1810.402 1236.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15326",
    "data-name": "Path 15326",
    d: "M599.97,499.206l-81.077,46.808L391.384,472.4V325.155l127.51-73.619,81.077,46.808v-1.285l-80.8-46.648-.279-.161-128.344,74.1-.278.16V473.038l128.344,74.1.277.161,81.077-46.809Z",
    transform: "translate(-390.272 -250.249)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861",
    transform: "translate(0 1458.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15327",
    "data-name": "Path 15327",
    d: "M24.951,297.408l-.278-.161L6.7,307.624v1.286l17.972-10.376,127.51,73.62v42.709H153.3V371.51Z",
    transform: "translate(-6.701 -297.247)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862",
    transform: "translate(145.483 1458.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15328",
    "data-name": "Path 15328",
    d: "M38.636,414.862V372.153l127.515-73.62,127.515,73.62v42.709h1.113V371.51l-128.349-74.1-.278-.161L37.8,371.349l-.278.161v43.352Z",
    transform: "translate(-37.524 -297.247)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863",
    transform: "translate(401.624 1458.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15329",
    "data-name": "Path 15329",
    d: "M92.906,414.862V372.153l127.515-73.62,127.515,73.62v42.709h1.112V371.51L220.7,297.408l-.277-.161-128.349,74.1-.278.161v43.352Z",
    transform: "translate(-91.793 -297.247)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864",
    transform: "translate(657.766 1458.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15330",
    "data-name": "Path 15330",
    d: "M147.174,414.862V372.153l127.515-73.62L402.2,372.153v42.709h1.112V371.51l-128.349-74.1-.278-.161-128.349,74.1-.278.161v43.352Z",
    transform: "translate(-146.062 -297.247)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865",
    transform: "translate(1682.331 1458.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15331",
    "data-name": "Path 15331",
    d: "M364.25,414.862V372.153l127.515-73.62,127.51,73.62v42.709h1.112V371.51l-128.345-74.1-.278-.161-128.349,74.1-.279.161v43.352Z",
    transform: "translate(-363.137 -297.247)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866",
    transform: "translate(1938.469 1485.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15332",
    "data-name": "Path 15332",
    d: "M499.037,303l-81.355,46.97-.277.161v43.352h1.112V350.769l80.52-46.487Z",
    transform: "translate(-417.405 -302.996)",
    fill: "#b7c1f5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868",
    transform: "translate(1515.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15333",
    "data-name": "Path 15333",
    d: "M661.636-11.833V138.878L497.624,233.57,333.612,138.878V-11.833h-5.8V142.224l169.81,98.038,169.81-98.038V-11.833Z",
    transform: "translate(-327.813 11.833)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869",
    transform: "translate(1849.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15334",
    "data-name": "Path 15334",
    d: "M404.338,138.878v-864.71h-5.8V142.224l169.8,98.038.867-.5V233.07l-.867.5Z",
    transform: "translate(-398.541 11.833)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870",
    transform: "translate(0 235.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15335",
    "data-name": "Path 15335",
    d: "M6.7,38.165v6.694L20.109,52.6V241.987L6.7,249.728v6.693l19.207-11.088V49.254Z",
    transform: "translate(-6.701 -38.165)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871",
    transform: "translate(13.411 149.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15336",
    "data-name": "Path 15336",
    d: "M179.348,411.9,9.542,313.861V117.784L179.348,19.743,349.16,117.784V313.861ZM15.338,310.515l164.01,94.695,164.015-94.695V121.13L179.348,26.436,15.338,121.13Z",
    transform: "translate(-9.542 -19.743)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872",
    transform: "translate(2016.336 244.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15337",
    "data-name": "Path 15337",
    d: "M437.668,40.054,433.9,42.228V238.307l3.765,2.173Z",
    transform: "translate(-433.903 -40.054)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873",
    transform: "translate(0 438.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15338",
    "data-name": "Path 15338",
    d: "M23.008,80.995,6.7,90.41V97.1l16.308-9.415,164.013,94.692V371.765L23.008,466.458,6.7,457.042v6.692l16.308,9.415,169.81-98.038V179.033Z",
    transform: "translate(-6.701 -80.995)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6874",
    "data-name": "Group 6874",
    transform: "translate(180.319 438.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15339",
    "data-name": "Path 15339",
    d: "M214.716,473.149,44.9,375.108V179.031L214.716,80.995l169.811,98.036V375.108ZM50.706,371.762l164.01,94.694,164.01-94.694V182.378l-164.01-94.69-164.01,94.69Z",
    transform: "translate(-44.905 -80.995)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6875",
    "data-name": "Group 6875",
    transform: "translate(0 814.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15340",
    "data-name": "Path 15340",
    d: "M6.7,160.668v6.694L20.109,175.1V364.49L6.7,372.231v6.694l19.207-11.089V171.757Z",
    transform: "translate(-6.701 -160.668)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6876",
    "data-name": "Group 6876",
    transform: "translate(13.411 727.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15341",
    "data-name": "Path 15341",
    d: "M179.348,534.4,9.542,436.364V240.282l169.806-98.036L349.16,240.282V436.364ZM15.338,433.018l164.01,94.69,164.015-94.69V243.629l-164.015-94.69-164.01,94.69Z",
    transform: "translate(-9.542 -142.246)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6877",
    "data-name": "Group 6877",
    transform: "translate(1682.519 727.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15342",
    "data-name": "Path 15342",
    d: "M700.76,239.112,532.988,142.246,363.177,240.282V436.364L532.988,534.4,700.76,437.535Zm-167.772,288.6-164.015-94.69V243.629l164.015-94.69,164.006,94.69V433.018Z",
    transform: "translate(-363.177 -142.246)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6878",
    "data-name": "Group 6878",
    transform: "translate(0 1016.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15343",
    "data-name": "Path 15343",
    d: "M23.008,203.5,6.7,212.912v6.693l16.308-9.415,164.013,94.692V494.269L23.008,588.96,6.7,579.545v6.692l16.308,9.415,169.81-98.038V301.535Z",
    transform: "translate(-6.701 -203.497)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6879",
    "data-name": "Group 6879",
    transform: "translate(180.319 1016.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15344",
    "data-name": "Path 15344",
    d: "M214.716,595.651,44.9,497.615V301.538L214.716,203.5l169.811,98.041V497.615ZM50.706,494.269l164.01,94.694,164.01-94.694V304.884L214.716,210.19,50.706,304.884Z",
    transform: "translate(-44.905 -203.497)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6880",
    "data-name": "Group 6880",
    transform: "translate(1515.61 1016.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15345",
    "data-name": "Path 15345",
    d: "M497.62,595.651,327.814,497.615V301.538L497.62,203.5l169.811,98.041V497.615ZM333.61,494.269l164.01,94.694,164.015-94.694V304.884L497.62,210.19,333.61,304.884Z",
    transform: "translate(-327.814 -203.497)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6881",
    "data-name": "Group 6881",
    transform: "translate(1849.431 1016.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15346",
    "data-name": "Path 15346",
    d: "M569.211,588.46l-.867.5L404.338,494.269V304.882L568.344,210.19l.867.5V204l-.867-.5-169.8,98.038V497.614l169.8,98.038.867-.5Z",
    transform: "translate(-398.541 -203.497)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6882",
    "data-name": "Group 6882",
    transform: "translate(0 1392.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15347",
    "data-name": "Path 15347",
    d: "M6.7,283.171v6.694l13.408,7.741v169.62h5.8V294.26Z",
    transform: "translate(-6.701 -283.171)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6883",
    "data-name": "Group 6883",
    transform: "translate(13.408 1305.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15348",
    "data-name": "Path 15348",
    d: "M15.34,535.753V366.133l164.012-94.692,164.013,94.692v169.62h5.8V362.787l-169.81-98.038L9.541,362.787V535.753Z",
    transform: "translate(-9.541 -264.749)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6884",
    "data-name": "Group 6884",
    transform: "translate(347.231 1305.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15349",
    "data-name": "Path 15349",
    d: "M86.066,972.753V366.133l164.013-94.692L414.09,366.133v169.62h5.8V362.787L250.079,264.749,80.269,362.787V972.753Z",
    transform: "translate(-80.269 -264.749)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6885",
    "data-name": "Group 6885",
    transform: "translate(681.053 1305.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15350",
    "data-name": "Path 15350",
    d: "M156.793,535.753V366.133l164.013-94.692,164.012,94.692v169.62h5.8V362.787l-169.81-98.038L151,362.787V535.753Z",
    transform: "translate(-150.996 -264.749)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6886",
    "data-name": "Group 6886",
    transform: "translate(1014.875 1305.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15351",
    "data-name": "Path 15351",
    d: "M227.521,535.753V366.133l164.012-94.692,164.011,94.692v169.62h5.8V362.787l-169.81-98.038-169.81,98.038V535.753Z",
    transform: "translate(-221.723 -264.749)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887",
    transform: "translate(1348.696 1305.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15352",
    "data-name": "Path 15352",
    d: "M298.249,535.753V366.133L462.26,271.441l164.013,94.692v169.62h5.8V362.787L462.26,264.749,292.45,362.787V535.753Z",
    transform: "translate(-292.45 -264.749)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6888",
    "data-name": "Group 6888",
    transform: "translate(1682.519 1305.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15353",
    "data-name": "Path 15353",
    d: "M700.758,535.753V361.613L532.986,264.749,363.177,362.787V535.753h5.8V366.133l164.012-94.692,164.007,94.692v169.62Z",
    transform: "translate(-363.177 -264.749)",
    fill: "#b7c1f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6889",
    "data-name": "Group 6889",
    transform: "translate(2016.336 1401.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15354",
    "data-name": "Path 15354",
    d: "M437.668,285.06l-3.765,2.174V460.2h3.765Z",
    transform: "translate(-433.903 -285.06)",
    fill: "#b7c1f5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6891",
    "data-name": "Group 6891",
    transform: "translate(0.002 112.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15355",
    "data-name": "Path 15355",
    d: "M21.917,41.28A14.476,14.476,0,1,0,7.441,26.8,14.475,14.475,0,0,0,21.917,41.28Z",
    transform: "translate(-3.948 -10.494)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1232",
    "data-name": "Ellipse 1232",
    cx: 13.357,
    cy: 13.357,
    r: 13.357,
    transform: "translate(1029.174 2.953)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15356",
    "data-name": "Path 15356",
    d: "M291.84,38.056a12.673,12.673,0,1,0-12.673-12.673A12.671,12.671,0,0,0,291.84,38.056Z",
    transform: "translate(1006.835 -9.073)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1233",
    "data-name": "Ellipse 1233",
    cx: 7.998,
    cy: 7.998,
    r: 7.998,
    transform: "translate(1418.745 82.253)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15357",
    "data-name": "Path 15357",
    d: "M428.426,55.8a13.834,13.834,0,1,0-13.834-13.834A13.837,13.837,0,0,0,428.426,55.8Z",
    transform: "translate(1510.597 48.287)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1234",
    "data-name": "Ellipse 1234",
    cx: 16.31,
    cy: 16.31,
    r: 16.31,
    transform: "translate(1794.644)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15358",
    "data-name": "Path 15358",
    d: "M273.74,39.446A10.639,10.639,0,1,0,263.1,50.084,10.638,10.638,0,0,0,273.74,39.446Z",
    transform: "translate(907.499 50.805)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 8.577,
    cy: 8.577,
    r: 8.577,
    transform: "translate(1546.236 7.733)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1236",
    "data-name": "Ellipse 1236",
    cx: 9.19,
    cy: 9.19,
    r: 9.19,
    transform: "translate(1673.693 81.062)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15359",
    "data-name": "Path 15359",
    d: "M426.864,59.882a11.852,11.852,0,1,0,11.852,11.852A11.853,11.853,0,0,0,426.864,59.882Z",
    transform: "translate(1512.159 166.4)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15360",
    "data-name": "Path 15360",
    d: "M35.865,131.667a8.39,8.39,0,1,0,8.387-8.387A8.391,8.391,0,0,0,35.865,131.667Z",
    transform: "translate(101.785 402.232)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1237",
    "data-name": "Ellipse 1237",
    cx: 13.689,
    cy: 13.689,
    r: 13.689,
    transform: "translate(1413.054 224.446)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15361",
    "data-name": "Path 15361",
    d: "M333.108,89.263a14.216,14.216,0,1,0,14.216-14.216A14.216,14.216,0,0,0,333.108,89.263Z",
    transform: "translate(1207.488 222.812)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1238",
    "data-name": "Ellipse 1238",
    cx: 8.591,
    cy: 8.591,
    r: 8.591,
    transform: "translate(1674.293 525.31)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15362",
    "data-name": "Path 15362",
    d: "M344.936,107.021a11.186,11.186,0,1,0,11.186,11.186A11.186,11.186,0,0,0,344.936,107.021Z",
    transform: "translate(1209.876 341.751)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1239",
    "data-name": "Ellipse 1239",
    cx: 11.937,
    cy: 11.937,
    r: 11.937,
    transform: "translate(1670.947 226.198)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1240",
    "data-name": "Ellipse 1240",
    cx: 16.955,
    cy: 16.955,
    r: 16.955,
    transform: "translate(1793.999 443.005)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15363",
    "data-name": "Path 15363",
    d: "M425.071,142.181a9.577,9.577,0,1,0-9.577-9.577A9.574,9.574,0,0,0,425.071,142.181Z",
    transform: "translate(1513.952 401.294)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15364",
    "data-name": "Path 15364",
    d: "M403.609,108.058a16.777,16.777,0,1,0-16.774-16.779A16.777,16.777,0,0,0,403.609,108.058Z",
    transform: "translate(1407.344 220.796)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15365",
    "data-name": "Path 15365",
    d: "M23.379,138.592A16.331,16.331,0,1,0,7.048,122.262,16.33,16.33,0,0,0,23.379,138.592Z",
    transform: "translate(-5.41 337.696)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15366",
    "data-name": "Path 15366",
    d: "M48.575,181.2A13.874,13.874,0,1,0,34.7,167.322,13.875,13.875,0,0,0,48.575,181.2Z",
    transform: "translate(97.463 514.46)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15367",
    "data-name": "Path 15367",
    d: "M103.693,161.582a6.589,6.589,0,1,0-6.589,6.594A6.589,6.589,0,0,0,103.693,161.582Z",
    transform: "translate(305.075 520.2)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1241",
    "data-name": "Ellipse 1241",
    cx: 12.753,
    cy: 12.753,
    r: 12.753,
    transform: "translate(517.497 742.972)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15368",
    "data-name": "Path 15368",
    d: "M168.2,166.094a12.316,12.316,0,1,0-12.314,12.319A12.314,12.314,0,0,0,168.2,166.094Z",
    transform: "translate(502.433 515.688)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1242",
    "data-name": "Ellipse 1242",
    cx: 14.417,
    cy: 14.417,
    r: 14.417,
    transform: "translate(771.974 741.308)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15369",
    "data-name": "Path 15369",
    d: "M8.234,211.847a10.733,10.733,0,1,0,10.733-10.733A10.731,10.731,0,0,0,8.234,211.847Z",
    transform: "translate(-0.998 691.763)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15370",
    "data-name": "Path 15370",
    d: "M23.666,177.854a7.358,7.358,0,1,0-7.358,7.363A7.358,7.358,0,0,0,23.666,177.854Z",
    transform: "translate(1.661 577.869)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1243",
    "data-name": "Ellipse 1243",
    cx: 6.028,
    cy: 6.028,
    r: 6.028,
    transform: "translate(268.082 749.697)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15371",
    "data-name": "Path 15371",
    d: "M89.762,227.048A10.143,10.143,0,1,0,99.9,216.9,10.141,10.141,0,0,0,89.762,227.048Z",
    transform: "translate(302.274 750.504)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15372",
    "data-name": "Path 15372",
    d: "M76.294,200.292A14.61,14.61,0,1,0,90.9,214.9,14.612,14.612,0,0,0,76.294,200.292Z",
    transform: "translate(197.817 688.706)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1244",
    "data-name": "Ellipse 1244",
    cx: 15.765,
    cy: 15.765,
    r: 15.765,
    transform: "translate(770.626 887.844)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15373",
    "data-name": "Path 15373",
    d: "M369.482,217.38a7.9,7.9,0,1,0,7.9,7.9A7.9,7.9,0,0,0,369.482,217.38Z",
    transform: "translate(1313.403 752.271)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1245",
    "data-name": "Ellipse 1245",
    cx: 9.222,
    cy: 9.222,
    r: 9.222,
    transform: "translate(1673.662 672.562)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1246",
    "data-name": "Ellipse 1246",
    cx: 18.007,
    cy: 18.007,
    r: 18.007,
    transform: "translate(1792.947 737.718)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15374",
    "data-name": "Path 15374",
    d: "M425.238,173.9a9.791,9.791,0,1,0-9.789-9.794A9.794,9.794,0,0,0,425.238,173.9Z",
    transform: "translate(1513.785 517.678)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1247",
    "data-name": "Ellipse 1247",
    cx: 9.707,
    cy: 9.707,
    r: 9.707,
    transform: "translate(136.331 967.842)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15375",
    "data-name": "Path 15375",
    d: "M50.163,278.794a15.887,15.887,0,1,0-15.887-15.887A15.887,15.887,0,0,0,50.163,278.794Z",
    transform: "translate(95.874 862.527)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1248",
    "data-name": "Ellipse 1248",
    cx: 16.593,
    cy: 16.593,
    r: 16.593,
    transform: "translate(513.657 887.016)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15376",
    "data-name": "Path 15376",
    d: "M144.887,223.867a6.1,6.1,0,1,0,6.1-6.107A6.1,6.1,0,0,0,144.887,223.867Z",
    transform: "translate(507.332 753.684)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1249",
    "data-name": "Ellipse 1249",
    cx: 12.241,
    cy: 12.241,
    r: 12.241,
    transform: "translate(774.149 1187.133)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15377",
    "data-name": "Path 15377",
    d: "M160.929,246.421a18.712,18.712,0,1,0,18.714,18.714A18.713,18.713,0,0,0,160.929,246.421Z",
    transform: "translate(497.392 860.299)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15378",
    "data-name": "Path 15378",
    d: "M382.261,258.763a10.629,10.629,0,1,0-10.629,10.629A10.631,10.631,0,0,0,382.261,258.763Z",
    transform: "translate(1311.253 866.671)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15379",
    "data-name": "Path 15379",
    d: "M428.437,243.82a13.85,13.85,0,1,0-13.848-13.848A13.852,13.852,0,0,0,428.437,243.82Z",
    transform: "translate(1510.586 747.58)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15380",
    "data-name": "Path 15380",
    d: "M428.422,247.455a13.832,13.832,0,1,0,13.834,13.834A13.831,13.831,0,0,0,428.422,247.455Z",
    transform: "translate(1510.6 864.145)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15381",
    "data-name": "Path 15381",
    d: "M24.67,261.734A20.288,20.288,0,0,0,6.7,272.693v18.842a20.341,20.341,0,1,0,17.969-29.8Z",
    transform: "translate(-6.701 917.261)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15382",
    "data-name": "Path 15382",
    d: "M44.576,328.782a8.8,8.8,0,1,0-8.8-8.8A8.8,8.8,0,0,0,44.576,328.782Z",
    transform: "translate(101.461 1101.216)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15383",
    "data-name": "Path 15383",
    d: "M78.474,328.459a17.379,17.379,0,1,0-17.379-17.379A17.382,17.382,0,0,0,78.474,328.459Z",
    transform: "translate(195.637 1036.178)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15384",
    "data-name": "Path 15384",
    d: "M74.478,263.444a12.307,12.307,0,1,0,12.3,12.309A12.312,12.312,0,0,0,74.478,263.444Z",
    transform: "translate(199.632 923.622)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15385",
    "data-name": "Path 15385",
    d: "M102.952,275.439A14.011,14.011,0,1,0,88.943,261.43,14.01,14.01,0,0,0,102.952,275.439Z",
    transform: "translate(299.228 864.004)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15386",
    "data-name": "Path 15386",
    d: "M147.694,278.681A16.022,16.022,0,1,0,131.67,294.7,16.024,16.024,0,0,0,147.694,278.681Z",
    transform: "translate(398.578 920.695)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15387",
    "data-name": "Path 15387",
    d: "M156.108,335.571a12.595,12.595,0,1,0-12.6-12.593A12.594,12.594,0,0,0,156.108,335.571Z",
    transform: "translate(502.213 1098.221)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1250",
    "data-name": "Ellipse 1250",
    cx: 13.3,
    cy: 13.3,
    r: 13.3,
    transform: "translate(773.091 1333.957)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15388",
    "data-name": "Path 15388",
    d: "M344.791,285.725a11,11,0,1,0-11-11A11,11,0,0,0,344.791,285.725Z",
    transform: "translate(1210.021 924.653)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1251",
    "data-name": "Ellipse 1251",
    cx: 12.172,
    cy: 12.172,
    r: 12.172,
    transform: "translate(1798.782 1187.202)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15389",
    "data-name": "Path 15389",
    d: "M15.708,295.985a6.6,6.6,0,1,0,6.6,6.6A6.6,6.6,0,0,0,15.708,295.985Z",
    transform: "translate(2.26 1044.67)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15390",
    "data-name": "Path 15390",
    d: "M105,309.532a16.6,16.6,0,1,0,16.6,16.6A16.6,16.6,0,0,0,105,309.532Z",
    transform: "translate(297.182 1095.063)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1252",
    "data-name": "Ellipse 1252",
    cx: 7.433,
    cy: 7.433,
    r: 7.433,
    transform: "translate(522.817 1339.824)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1253",
    "data-name": "Ellipse 1253",
    cx: 9.827,
    cy: 9.827,
    r: 9.827,
    transform: "translate(904.634 1411.371)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15391",
    "data-name": "Path 15391",
    d: "M345.829,294.774a12.319,12.319,0,1,0,12.319,12.319A12.318,12.318,0,0,0,345.829,294.774Z",
    transform: "translate(1208.983 1040.165)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15392",
    "data-name": "Path 15392",
    d: "M361.8,318.466a6.87,6.87,0,1,0,6.872-6.872A6.872,6.872,0,0,0,361.8,318.466Z",
    transform: "translate(1314.214 1102.734)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15393",
    "data-name": "Path 15393",
    d: "M400.474,294.672a12.8,12.8,0,1,0,12.8,12.8A12.8,12.8,0,0,0,400.474,294.672Z",
    transform: "translate(1410.48 1039.786)",
    fill: "#b7c1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15394",
    "data-name": "Path 15394",
    d: "M429.464,309.839a15.153,15.153,0,1,0,15.156,15.155A15.154,15.154,0,0,0,429.464,309.839Z",
    transform: "translate(1509.559 1096.205)",
    fill: "#b7c1f5"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBackgroundS1);
export default __webpack_public_path__ + "static/media/roadmap-background-s1.8fa2af2cd3585f7da37287f24de371e2.svg";
export { ForwardRef as ReactComponent };